import React, { FC } from 'react';

import { UseFormReturn } from 'react-hook-form';

import { FormControl, FormField, FormItem, UISwitch } from 'components/ui';

import { DailyBonusFormFields } from '../DailyBonusForm.consts';

interface IRestartAfterCompletionSectionProps {
  form: UseFormReturn<DailyBonusFormFields>;
}

const RestartAfterCompletionSection: FC<
  IRestartAfterCompletionSectionProps
> = ({ form }): React.ReactElement => {
  return (
    <div className="mb-24 border border-base-border rounded-[10px] p-[17px] flex flex-col items-center w-full">
      <div className="flex items-center justify-between w-full">
        <p className="text-p-m font-semibold leading-6 text-base-foreground w-[237px]">
          Restart After Completion
        </p>
        <FormField
          control={form.control}
          name="startOver"
          render={({ field: { value, onChange } }): React.ReactElement => (
            <FormItem>
              <FormControl>
                <UISwitch
                  checked={value}
                  onCheckedChange={onChange}
                  data-testid="dashDailyBonusRestartAfterCompletion"
                  className="h-6 w-11 shadow-none data-[state=checked]:bg-indigo-600 data-[state=unchecked]:bg-base-input [&>span]:h-5 [&>span]:w-5 [&>span]:bg-base-background data-[state=checked]:[&>span]:translate-x-5 data-[state=unchecked]:[&>span]:translate-x-0"
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export { RestartAfterCompletionSection };
